var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.375C1 2.75273 1.50273 2.25 2.125 2.25H15.625C16.2473 2.25 16.75 2.75273 16.75 3.375C16.75 3.99727 16.2473 4.5 15.625 4.5H2.125C1.50273 4.5 1 3.99727 1 3.375ZM1 9C1 8.37773 1.50273 7.875 2.125 7.875H15.625C16.2473 7.875 16.75 8.37773 16.75 9C16.75 9.62227 16.2473 10.125 15.625 10.125H2.125C1.50273 10.125 1 9.62227 1 9ZM16.75 14.625C16.75 15.2473 16.2473 15.75 15.625 15.75H2.125C1.50273 15.75 1 15.2473 1 14.625C1 14.0027 1.50273 13.5 2.125 13.5H15.625C16.2473 13.5 16.75 14.0027 16.75 14.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_8480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.52b27fd7b126caa7e59da48b27d1d715.svg";
export { ForwardRef as ReactComponent };